export const cilPaperPlane = ["24 24","<path d='M21.408 0.931c-0.164-0.137-0.377-0.22-0.609-0.22-0.146 0-0.285 0.033-0.409 0.092l0.006-0.002-19.646 9.222v1.784l8.252 3.301 5.293 8.143h1.785l5.639-21.347c0.020-0.072 0.031-0.156 0.031-0.241 0-0.293-0.132-0.555-0.34-0.73l-0.001-0.001zM14.977 21.548l-4.55-7 7.001-7.668-1.108-1.011-7.056 7.728-6.804-2.721 17.505-8.217z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-paper-plane.js
// module id = null
// module chunks = 